module.exports = __webpack_public_path__ + "img/gj1_mb.2676931a.jpg";